import { Button, Stack, styled } from '@mui/material'

export const TinyButton = styled(Button)`
  font-size: 12px;
  line-height: 12px;
  padding: 4px 8px;
  font-weight: 400;
`
TinyButton.defaultProps = {
  size: 'small',
  variant: 'text',
}

export const DevActionsGroup = styled(Stack)`
  gap: 4px;
  padding: 4px;
`
